import React from 'react'
import { Navigate } from 'react-router-dom'
import Private from '../../pages/_layouts/Private'
import { useAuthStore } from '../../store/auth'
import { useUserStore } from '../../store/user'

export interface PrivateRouteProps {
  Component: React.FunctionComponent
  title?: string
  fullPage?: boolean
  adminOnly?: boolean
  allowedRoles?: string[]
}

const PrivateRoute: React.FunctionComponent<PrivateRouteProps> = ({
  Component,
  title,
  fullPage,
  adminOnly,
  allowedRoles,
}) => {
  const { signed, token } = useAuthStore((state) => state)
  const { user } = useUserStore((state) => state)

  // 1. Não autenticado: redirecionar imediatamente para o login sem montar layout privado
  if (!signed || !token) {
    return <Navigate to='/login' replace />
  }

  // 2. Rota restrita a administradores
  if (adminOnly && user?.role !== 'admin') {
    return <Navigate to='/documents' replace />
  }

  // 3. Rota restrita a perfis específicos
  if (allowedRoles && allowedRoles.length > 0 && user?.role && !allowedRoles.includes(user.role)) {
    return <Navigate to='/documents' replace />
  }

  return (
    <Private fullPage={fullPage} title={title}>
      <Component />
    </Private>
  )
}

export default PrivateRoute

